import { fetchApi } from '@/config/axiosSetting';
import { GetAdjusterPerformanceScoreQueryResponseType } from './getAdjusterPerformanceScoreQuery.type';

export const getAdjusterPerformanceScoreFunction =
  (): Promise<GetAdjusterPerformanceScoreQueryResponseType> => {
    return fetchApi.get('/homepage/performance_score/');
  };
